(() => {
  class ProductSocialShare {
    constructor(root) {
      this.root = root;
      this.copyButton = root.querySelector('[data-product-copy-link]');
      this.status = root.querySelector('[data-product-share-status]');

      if (!this.copyButton) return;

      this.copyButton.addEventListener('click', () => {
        this.copyLink();
      });
    }

    async copyLink() {
      const url = this.copyButton.dataset.shareUrl;

      if (!url) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          this.fallbackCopy(url);
        }

        this.showStatus('Link copied');
      } catch (error) {
        try {
          this.fallbackCopy(url);
          this.showStatus('Link copied');
        } catch (fallbackError) {
          this.showStatus('Unable to copy link');
        }
      }
    }

    fallbackCopy(text) {
      const textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);

      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const copied = document.execCommand('copy');

      textarea.remove();

      if (!copied) {
        throw new Error('Copy command failed');
      }
    }

    showStatus(message) {
      if (!this.status) return;

      this.status.textContent = message;
      this.status.hidden = false;

      window.clearTimeout(this.statusTimer);

      this.statusTimer = window.setTimeout(() => {
        this.status.hidden = true;
      }, 2500);
    }
  }

  const init = () => {
    document
      .querySelectorAll('[data-product-social-share]')
      .forEach((root) => {
        if (root.dataset.productShareInitialized === 'true') return;

        root.dataset.productShareInitialized = 'true';

        new ProductSocialShare(root);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true,
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();